import { arr, uniqueId } from "../../others/oneliners";
import { ImgSkeleton, SpanSkeleton } from "../skeletonTemplates/skeletons";

interface props {
    contacts: Array<any>;
    skeleton?: boolean;
}

const Contact = ({ contacts, skeleton }: props): JSX.Element => {
    if (skeleton) return <ContactSkeleton />
    return (
        <div className="w-[260px] flex flex-col gap-1">
            <h3>Contact</h3>
        </div>
    )
}

export default Contact

export const ContactSkeleton = (): JSX.Element => {
    return (
        <div className="w-[260px] flex flex-col gap-1">
            <h3>Contact</h3>
            {
                arr(3, '').map(() => {
                    return (
                        <div className="flex items-center gap-2 mb-2" key={uniqueId()}>
                            <ImgSkeleton width={24} height={24} />
                            <SpanSkeleton width="w-[100px]" />
                        </div>
                    )
                })
            }
        </div>
    )
}